var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{attrs:{"name":_vm.name,"draggable":true,"width":_vm.width,"height":"auto","clickToClose":false}},[_c('div',{staticClass:"modal-header"},[_c('h2',[_vm._v("確認")])]),_c('div',{staticClass:"modal-body"},[_vm._t("content")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }